import { observer } from "mobx-react-lite";
import React from "react";

import InvoiceStore from "stores/InvoiceStore";
import AppStore from "stores/AppStore";
import ErrorModal from "components/Header/components/Settings/components/ErrorModal/ErrorModal";
import Companies from "./components/Companies/Companies";
import Dates from "./components/Dates/Dates";
import InvoiceState from "./components/InvoiceState/InvoiceState";
import InvoiceSummary from "./components/InvoiceSummary/InvoiceSummary";

import "./InvoicePreview.scss";

const InvoicePreview = () => {
    const {
        invoice: {
            invoiceData: { status }
        }
    } = InvoiceStore;

    const { isErrorModalVisible } = AppStore;

    return (
        <div className="c-invoice-preview">
            <Companies />
            <Dates />
            {status === "missing" && <InvoiceSummary />}
            {status !== "missing" && <InvoiceState />}
            {isErrorModalVisible && <ErrorModal />}
        </div>
    );
};

export default observer(InvoicePreview);
